import fetchCommonData from "./fetchCommonData"
export default (() => {
    let onloads = [], data = []
    fetchCommonData({
        url: 'https://pay.wenhua.com.cn',
        title: '文华财经 - 小超市'
    }).then(res => {
        data = res
        onloads.forEach(fn => {
            fn(res)
        })
        onloads.length = 0
    })
    return  {
        onload (call) {
            if (data.length > 0) {
                call(data)
            } else {
                onloads.push(call)
            }
        }
    }
}) ()